<template>
    <span class="help-block text-danger" v-html="getMessage"></span>
</template>

<script>
export default {
    name: "InputErrors",
    props: {
        errors: {
            type: Array,
            default: null,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        getMessage() {
            if (this.multiple) {
                return this.errors.join("<br />");
            } else {
                return this.errors[0];
            }
        },
    },
};
</script>

<style scoped>

</style>
